import { render } from "./table.vue?vue&type=template&id=d669d108&scoped=true"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"

import "./table.vue?vue&type=style&index=0&id=d669d108&scoped=true&lang=css"

import exportComponent from "E:\\Backup\\FREELANCER\\Vue-Data-Table\\vue3\\data-table-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d669d108"]])

export default __exports__